import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17a61104"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }

import PageHeader from "./header/index.vue";
import PageFooter from "./footer/index.vue";
import ToolBar from "./toolBar/index.vue";
import { computed } from "vue";
import { useStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const isOwner = computed(() => store.state.common.isOwner);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageHeader, {
      oncontextmenu: "return false;",
      onselectstart: "return false"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          (_openBlock(), _createBlock(_KeepAlive, null, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ], 1024))
        ]),
        _: 1
      })
    ]),
    _createVNode(PageFooter, {
      oncontextmenu: "return false;",
      onselectstart: "return false"
    })
  ], 64))
}
}

})